import axios from 'axios';
import { history } from "./history";
import {alertActions} from "../actions/alert.actions";

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Unauthorized code
        if (error.response.status === 401) {
            alertActions.error({ name: "Unauthorized", status: 401 });
            history.push('/login');
        }
        return Promise.reject(error);
    }
);
